import React from 'react';
import { Link } from 'react-router-dom';
import AuthNavbar from '../../components/layout/AuthNavbar';
import { OPERATOR } from '../../legal/operator';

export default function LegalLayout({ title, lastUpdated, children }) {
  return (
    <>
      <AuthNavbar />
      <div style={s.page}>
        <article style={s.article}>
          <header style={s.header}>
            <h1 style={s.h1}>{title}</h1>
            <p style={s.meta}>
              Last updated: <strong>{lastUpdated || OPERATOR.effectiveDate}</strong>
            </p>
          </header>
          <div style={s.body}>{children}</div>

          <footer style={s.footer}>
            <nav style={s.nav}>
              <Link to="/privacy"       style={s.navLink}>Privacy Policy</Link>
              <Link to="/terms"         style={s.navLink}>Terms of Service</Link>
              <Link to="/cookies"       style={s.navLink}>Cookies</Link>
              <Link to="/subprocessors" style={s.navLink}>Subprocessors</Link>
              <Link to="/"              style={s.navLink}>Back to Inverow</Link>
            </nav>
          </footer>
        </article>
      </div>
    </>
  );
}

const s = {
  page:    { minHeight: 'calc(100vh - 71px)', background: 'var(--bg)', padding: '40px 16px 80px' },
  article: { maxWidth: '760px', margin: '0 auto', color: 'var(--text-primary)', lineHeight: 1.7, fontSize: '15px' },
  header:  { marginBottom: '24px', paddingBottom: '16px', borderBottom: '1px solid var(--border)' },
  h1:      { fontSize: '32px', fontWeight: 800, margin: '0 0 8px' },
  meta:    { color: 'var(--text-secondary)', fontSize: '14px', margin: 0 },
  body:    { display: 'flex', flexDirection: 'column', gap: '8px' },
  footer:  { marginTop: '40px', paddingTop: '20px', borderTop: '1px solid var(--border)' },
  nav:     { display: 'flex', flexWrap: 'wrap', gap: '16px' },
  navLink: { color: 'var(--accent)', textDecoration: 'none', fontSize: '14px', fontWeight: 600 },
};

// Re-usable typographic helpers for the body
export const L = {
  H2:   ({ children, ...rest }) => <h2 style={{ fontSize: '22px', fontWeight: 700, margin: '24px 0 8px' }} {...rest}>{children}</h2>,
  H3:   ({ children, ...rest }) => <h3 style={{ fontSize: '17px', fontWeight: 700, margin: '16px 0 6px' }} {...rest}>{children}</h3>,
  P:    ({ children, ...rest }) => <p  style={{ margin: '0 0 12px' }} {...rest}>{children}</p>,
  UL:   ({ children, ...rest }) => <ul style={{ margin: '0 0 12px 22px', padding: 0 }} {...rest}>{children}</ul>,
  OL:   ({ children, ...rest }) => <ol style={{ margin: '0 0 12px 22px', padding: 0 }} {...rest}>{children}</ol>,
  LI:   ({ children, ...rest }) => <li style={{ margin: '0 0 4px' }} {...rest}>{children}</li>,
  Mail: ({ to }) => <a href={`mailto:${to}`} style={{ color: 'var(--accent)' }}>{to}</a>,
  A:    ({ children, ...rest }) => <a target="_blank" rel="noopener noreferrer" style={{ color: 'var(--accent)' }} {...rest}>{children}</a>,
};
